module.exports = __webpack_public_path__ + "img/中雨-大雨.c0bc568e.png";